import { fork, call, put, all, takeEvery } from 'redux-saga/effects';
import asyncInterface from '../../../../asyncInterface';
import * as actionTypes from './actionTypes'

function fetchAccountData(fetchPayload) {
    const fetchData = asyncInterface.init();
    return fetchData.howItWorks.fetchAccountData(fetchPayload);
}

function* fetchHowItWorksDataWorker(fetchPayload) {
    try {
      const response = yield call(
        fetchAccountData,
        fetchPayload.payload.metaData
      );
      yield put({
        type: actionTypes.fetchHowItWorksDataSuccessType,
        payload: response.data
      });
    } catch (error) {
      yield put({
        type: actionTypes.howItWorksDataFailedType,
        error
      });
    }
  }

function* fetchHowItWorksDataWatcher() {
    yield takeEvery(actionTypes.fetchHowItWorksType , fetchHowItWorksDataWorker);
}

export default function* howItWorksSagaWatcher() {
    yield all([
      fork(fetchHowItWorksDataWatcher)
    ])
}